// Activity Classification options (mandatory dropdown on Emission Factor)
export const ACTIVITY_CLASSIFICATION_OPTIONS = [
  'Wastewater',
  'Water',
  'Waste',
  'Chemicals',
  'Miscellaneous',
  'Energy',
  'Transport',
];


// Categories for emission factors (sorted alphabetically)
export const EMISSION_CATEGORIES = [
  { value: 'business_travel', label: 'Business Travel' },
  { value: 'capital_goods', label: 'Capital Goods' },
  { value: 'downstream_leased_assets', label: 'Downstream Leased Assets' },
  { value: 'downstream_transportation_and_distribution', label: 'Downstream Transportation and Distribution' },
  { value: 'employee_commuting', label: 'Employee Commuting' },
  { value: 'end_of_life_treatment', label: 'End of Life Treatment' },
  { value: 'franchises', label: 'Franchises' },
  { value: 'fuel_and_energy_related_activities', label: 'Fuel and Energy Related Activities' },
  { value: 'fugitive_emissions', label: 'Fugitive Emissions' },
  { value: 'general_economic_activity', label: 'General Economic Activity' },
  { value: 'investments', label: 'Investments' },
  { value: 'mobile_combustion', label: 'Mobile Combustion' },
  { value: 'process_emissions', label: 'Process Emissions' },
  { value: 'processing_of_sold_products', label: 'Processing of Sold Products' },
  { value: 'purchased_energy', label: 'Purchased Energy' },
  { value: 'purchased_goods_and_services', label: 'Purchased Goods and Services' },
  { value: 'self_generated_electricity', label: 'Self Generated Electricity' },
  { value: 'stationary_combustion', label: 'Stationary Combustion' },
  { value: 'upstream_leased_assets', label: 'Upstream Leased Assets' },
  { value: 'upstream_transportation_and_distribution', label: 'Upstream Transportation and Distribution' },
  { value: 'use_of_sold_products', label: 'Use of Sold Products' },
  { value: 'waste_generated_in_operations', label: 'Waste Generated in Operations' },
];

// Category to Scope mapping (using display names)
export const CATEGORY_SCOPE_MAP = {
  'Stationary Combustion': '1',
  'Fugitive Emissions': '1',
  'Mobile Combustion': '1',
  'Self Generated Electricity': '1',
  'Process Emissions': '1',
  'Purchased Energy': '2',
  'Purchased Goods and Services': '3',
  'Capital Goods': '3',
  'Fuel and Energy Related Activities': '3',
  'Upstream Transportation and Distribution': '3',
  'Waste Generated in Operations': '3',
  'Business Travel': '3',
  'Employee Commuting': '3',
  'Upstream Leased Assets': '3',
  'Downstream Transportation and Distribution': '3',
  'Processing of Sold Products': '3',
  'Use of Sold Products': '3',
  'End of Life Treatment': '3',
  'Downstream Leased Assets': '3',
  'Franchises': '3',
  'Investments': '3',
  'General Economic Activity': '3',
};

// Get scope from category
export const getScopeFromCategory = (category) => {
  return CATEGORY_SCOPE_MAP[category] || '';
};

// Countries with ISO 2-digit codes
export const COUNTRIES = [
  { code: '*', name: '* Any Country' },
  { code: 'AF', name: 'Afghanistan' },
  { code: 'AL', name: 'Albania' },
  { code: 'DZ', name: 'Algeria' },
  { code: 'AD', name: 'Andorra' },
  { code: 'AO', name: 'Angola' },
  { code: 'AG', name: 'Antigua and Barbuda' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AM', name: 'Armenia' },
  { code: 'AU', name: 'Australia' },
  { code: 'AT', name: 'Austria' },
  { code: 'AZ', name: 'Azerbaijan' },
  { code: 'BS', name: 'Bahamas' },
  { code: 'BH', name: 'Bahrain' },
  { code: 'BD', name: 'Bangladesh' },
  { code: 'BB', name: 'Barbados' },
  { code: 'BY', name: 'Belarus' },
  { code: 'BE', name: 'Belgium' },
  { code: 'BZ', name: 'Belize' },
  { code: 'BJ', name: 'Benin' },
  { code: 'BT', name: 'Bhutan' },
  { code: 'BO', name: 'Bolivia' },
  { code: 'BA', name: 'Bosnia and Herzegovina' },
  { code: 'BW', name: 'Botswana' },
  { code: 'BR', name: 'Brazil' },
  { code: 'BN', name: 'Brunei' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'BF', name: 'Burkina Faso' },
  { code: 'BI', name: 'Burundi' },
  { code: 'KH', name: 'Cambodia' },
  { code: 'CM', name: 'Cameroon' },
  { code: 'CA', name: 'Canada' },
  { code: 'CV', name: 'Cape Verde' },
  { code: 'CF', name: 'Central African Republic' },
  { code: 'TD', name: 'Chad' },
  { code: 'CL', name: 'Chile' },
  { code: 'CN', name: 'China' },
  { code: 'CO', name: 'Colombia' },
  { code: 'KM', name: 'Comoros' },
  { code: 'CG', name: 'Congo' },
  { code: 'CD', name: 'Congo (DRC)' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'CI', name: 'Côte d\'Ivoire' },
  { code: 'HR', name: 'Croatia' },
  { code: 'CU', name: 'Cuba' },
  { code: 'CY', name: 'Cyprus' },
  { code: 'CZ', name: 'Czech Republic' },
  { code: 'DK', name: 'Denmark' },
  { code: 'DJ', name: 'Djibouti' },
  { code: 'DM', name: 'Dominica' },
  { code: 'DO', name: 'Dominican Republic' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'EG', name: 'Egypt' },
  { code: 'SV', name: 'El Salvador' },
  { code: 'GQ', name: 'Equatorial Guinea' },
  { code: 'ER', name: 'Eritrea' },
  { code: 'EE', name: 'Estonia' },
  { code: 'SZ', name: 'Eswatini' },
  { code: 'ET', name: 'Ethiopia' },
  { code: 'FJ', name: 'Fiji' },
  { code: 'FI', name: 'Finland' },
  { code: 'FR', name: 'France' },
  { code: 'GA', name: 'Gabon' },
  { code: 'GM', name: 'Gambia' },
  { code: 'GE', name: 'Georgia' },
  { code: 'DE', name: 'Germany' },
  { code: 'GH', name: 'Ghana' },
  { code: 'GR', name: 'Greece' },
  { code: 'GD', name: 'Grenada' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'GN', name: 'Guinea' },
  { code: 'GW', name: 'Guinea-Bissau' },
  { code: 'GY', name: 'Guyana' },
  { code: 'HT', name: 'Haiti' },
  { code: 'HN', name: 'Honduras' },
  { code: 'HK', name: 'Hong Kong SAR' },
  { code: 'HU', name: 'Hungary' },
  { code: 'IS', name: 'Iceland' },
  { code: 'IN', name: 'India' },
  { code: 'ID', name: 'Indonesia' },
  { code: 'IR', name: 'Iran' },
  { code: 'IQ', name: 'Iraq' },
  { code: 'IE', name: 'Ireland' },
  { code: 'IL', name: 'Israel' },
  { code: 'IT', name: 'Italy' },
  { code: 'JM', name: 'Jamaica' },
  { code: 'JP', name: 'Japan' },
  { code: 'JO', name: 'Jordan' },
  { code: 'KZ', name: 'Kazakhstan' },
  { code: 'KE', name: 'Kenya' },
  { code: 'KI', name: 'Kiribati' },
  { code: 'KP', name: 'North Korea' },
  { code: 'KR', name: 'South Korea' },
  { code: 'KW', name: 'Kuwait' },
  { code: 'KG', name: 'Kyrgyzstan' },
  { code: 'LA', name: 'Laos' },
  { code: 'LV', name: 'Latvia' },
  { code: 'LB', name: 'Lebanon' },
  { code: 'LS', name: 'Lesotho' },
  { code: 'LR', name: 'Liberia' },
  { code: 'LY', name: 'Libya' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'LT', name: 'Lithuania' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'MG', name: 'Madagascar' },
  { code: 'MW', name: 'Malawi' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'MV', name: 'Maldives' },
  { code: 'ML', name: 'Mali' },
  { code: 'MT', name: 'Malta' },
  { code: 'MH', name: 'Marshall Islands' },
  { code: 'MR', name: 'Mauritania' },
  { code: 'MU', name: 'Mauritius' },
  { code: 'MX', name: 'Mexico' },
  { code: 'FM', name: 'Micronesia' },
  { code: 'MD', name: 'Moldova' },
  { code: 'MC', name: 'Monaco' },
  { code: 'MN', name: 'Mongolia' },
  { code: 'ME', name: 'Montenegro' },
  { code: 'MA', name: 'Morocco' },
  { code: 'MZ', name: 'Mozambique' },
  { code: 'MM', name: 'Myanmar' },
  { code: 'NA', name: 'Namibia' },
  { code: 'NR', name: 'Nauru' },
  { code: 'NP', name: 'Nepal' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'NE', name: 'Niger' },
  { code: 'NG', name: 'Nigeria' },
  { code: 'MK', name: 'North Macedonia' },
  { code: 'NO', name: 'Norway' },
  { code: 'OM', name: 'Oman' },
  { code: 'PK', name: 'Pakistan' },
  { code: 'PW', name: 'Palau' },
  { code: 'PA', name: 'Panama' },
  { code: 'PG', name: 'Papua New Guinea' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'PE', name: 'Peru' },
  { code: 'PH', name: 'Philippines' },
  { code: 'PL', name: 'Poland' },
  { code: 'PT', name: 'Portugal' },
  { code: 'QA', name: 'Qatar' },
  { code: 'RO', name: 'Romania' },
  { code: 'RU', name: 'Russia' },
  { code: 'RW', name: 'Rwanda' },
  { code: 'KN', name: 'Saint Kitts and Nevis' },
  { code: 'LC', name: 'Saint Lucia' },
  { code: 'VC', name: 'Saint Vincent and the Grenadines' },
  { code: 'WS', name: 'Samoa' },
  { code: 'SM', name: 'San Marino' },
  { code: 'ST', name: 'Sao Tome and Principe' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'SN', name: 'Senegal' },
  { code: 'RS', name: 'Serbia' },
  { code: 'SC', name: 'Seychelles' },
  { code: 'SL', name: 'Sierra Leone' },
  { code: 'SG', name: 'Singapore' },
  { code: 'SK', name: 'Slovakia' },
  { code: 'SI', name: 'Slovenia' },
  { code: 'SB', name: 'Solomon Islands' },
  { code: 'SO', name: 'Somalia' },
  { code: 'ZA', name: 'South Africa' },
  { code: 'SS', name: 'South Sudan' },
  { code: 'ES', name: 'Spain' },
  { code: 'LK', name: 'Sri Lanka' },
  { code: 'SD', name: 'Sudan' },
  { code: 'SR', name: 'Suriname' },
  { code: 'SE', name: 'Sweden' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'SY', name: 'Syria' },
  { code: 'TW', name: 'Taiwan' },
  { code: 'TJ', name: 'Tajikistan' },
  { code: 'TZ', name: 'Tanzania' },
  { code: 'TH', name: 'Thailand' },
  { code: 'TL', name: 'Timor-Leste' },
  { code: 'TG', name: 'Togo' },
  { code: 'TO', name: 'Tonga' },
  { code: 'TT', name: 'Trinidad and Tobago' },
  { code: 'TN', name: 'Tunisia' },
  { code: 'TR', name: 'Turkey' },
  { code: 'TM', name: 'Turkmenistan' },
  { code: 'TV', name: 'Tuvalu' },
  { code: 'UG', name: 'Uganda' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'US', name: 'United States' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'UZ', name: 'Uzbekistan' },
  { code: 'VU', name: 'Vanuatu' },
  { code: 'VA', name: 'Vatican City' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'YE', name: 'Yemen' },
  { code: 'ZM', name: 'Zambia' },
  { code: 'ZW', name: 'Zimbabwe' },
];

// Unit mapping with auto-populated unit categories
export const UNITS = [
  { unit: 'bag', category: 'UNIT' },
  { unit: 'tonne', category: 'WEIGHT' },
  { unit: 'kWh', category: 'ENERGY' },
  { unit: 'short ton', category: 'WEIGHT' },
  { unit: 'minutes', category: 'TIME' },
  { unit: 'mile', category: 'DISTANCE' },
  { unit: 'pair', category: 'INPUT_INDEPENDENT_UNIT' },
  { unit: 'kg', category: 'WEIGHT' },
  { unit: 'TJ', category: 'ENERGY' },
  { unit: 'packets', category: 'UNIT' },
  { unit: 'roll', category: 'UNIT' },
  { unit: 'number', category: 'UNIT' },
  { unit: 'can', category: 'UNIT' },
  { unit: 'tonne-mile', category: 'WEIGHT-DISTANCE' },
  { unit: 'short ton-mile', category: 'WEIGHT-DISTANCE' },
  { unit: 'tonne-km', category: 'WEIGHT-DISTANCE' },
  { unit: 'cubic metre', category: 'VOLUME' },
  { unit: 'passenger-mile', category: 'PASSENGER-DISTANCE' },
  { unit: 'passenger-km', category: 'PASSENGER-DISTANCE' },
  { unit: 'GJ', category: 'ENERGY' },
  { unit: 'metre', category: 'LENGTH' },
  { unit: 'set', category: 'UNIT' },
  { unit: 'litre', category: 'VOLUME' },
  { unit: 'scf', category: 'VOLUME' },
  { unit: 'pieces', category: 'UNIT' },
  { unit: 'passenger', category: 'UNIT' },
  { unit: 'barrel', category: 'UNIT' },
  { unit: 'MJ', category: 'ENERGY' },
  { unit: 'USD', category: 'CURRENCY' },
  { unit: 'room-night', category: 'UNIT' },
  { unit: 'km', category: 'DISTANCE' },
  { unit: 'MMBtu', category: 'ENERGY' },
  { unit: 'gallon', category: 'VOLUME' },
];

// Helper function to get unit category
export const getUnitCategory = (unit) => {
  const found = UNITS.find(u => u.unit.toUpperCase() === unit?.toUpperCase());
  return found?.category || '';
};

// Helper function to get country name from code
export const getCountryName = (code) => {
  const found = COUNTRIES.find(c => c.code === code);
  return found?.name || code;
};

// Helper function to get category label (works with both snake_case and display names)
export const getCategoryLabel = (value) => {
  if (!value) return value;
  // First try to find by value (snake_case)
  const foundByValue = EMISSION_CATEGORIES.find(c => c.value === value);
  if (foundByValue) return foundByValue.label;
  // If not found, check if it's already a label
  const foundByLabel = EMISSION_CATEGORIES.find(c => c.label === value);
  if (foundByLabel) return foundByLabel.label;
  // Return as-is if not found
  return value;
};
